module.exports = __webpack_public_path__ + "img/logo.ba478583.png";